import { useEffect } from 'react';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';

const GlobalSettingsTastic = ({ data }) => {
  useEffect(() => {
    if (!data) return;

    const isShowDiscountTags = JSON.parse(
      localStorage?.getItem('isShowDiscountTags') || '{}',
    )?.state;

    const shouldHideClickCollect = JSON.parse(
      localStorage?.getItem('shouldHideClickCollect') || '{}',
    )?.state;

    const vipDiscountForUser = JSON.parse(
      localStorage?.getItem('vipDiscountForUser') || 10,
    )?.state;

    if (shouldHideClickCollect !== data?.shouldHideClickCollect) {
      localStorage.setItem(
        'shouldHideClickCollect',
        JSON.stringify({ state: data.shouldHideClickCollect }),
      );
    }

    if (isShowDiscountTags !== data?.showDiscountTags) {
      localStorage.setItem(
        'isShowDiscountTags',
        JSON.stringify({ state: data.showDiscountTags }),
      );
    }

    if (vipDiscountForUser !== data?.vipDiscount) {
      localStorage.setItem(
        'vipDiscountForUser',
        JSON.stringify({ state: data.vipDiscount }),
      );
    }
  }, [data]);

  return null;
};

export default tastify({
  translate: true,
  connect: {
    node: true,
  },
})(GlobalSettingsTastic);
